// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__32mLz","CloseAction":"Modal_CloseAction__1eLg8","OnTop":"Modal_OnTop__-6yb6"};